export default {
  methods: {
    filterPhoneNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which
      if (keyCode != 43 && (keyCode < 48 || keyCode > 57)) {
        $event.preventDefault()
      }
    },
  },
}
